import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { OrderModel } from './model/order.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  
  getOrderList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/shop/orders/get', requestData);

  }
  sendEmail(requestData:any): Observable<any> {
    return this.http.post(environment.baseUrl+'/receipt/send-receipt', requestData);

  }
  getById(id:any): Observable<any> {
    return this.http.post(environment.baseUrl+'/shop/orders/get/'+id, '');

  }

}